import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import TeamMemberRowActionButtons from '@components/table/actionButtons/TeamMemberRowActionButtons';

import Button from '@components/smartAdminUI/Button';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

const TeamLeadersTable = ({
  id = 'teamLeadersTable',
  displayData,
  showDeleteButton = true,
  onMemberDelete,
  showStartImpersonationButton = false,
  isModal = false,
}) => {
  const onDeleteRow = row => onMemberDelete(row);

  const actionsFormatter = (cell, row) => (
    <TeamMemberRowActionButtons
      showDeleteButton={showDeleteButton}
      onDeleteRow={onDeleteRow}
      showStartImpersonationButton={showStartImpersonationButton}
      currRow={row}
    />
  );

  const columns = [
    {
      dataField: 'TeamLeadFullName',
      text: 'Name',
      formatter: cell => (
        <Stack direction="row" alignItems="center" gap={1}>
          <Avatar
            sx={{ width: 30, height: 30 }}
            alt={cell}
            src="/broken-image.jpg"
          />
          {cell}
        </Stack>
      ),
      sort: true,
      headerStyle: { width: '175px' },
    },
    {
      dataField: 'TeamLeadMlsId',
      text: 'MLS ID',
      sort: true,
      headerStyle: { width: '65px' },
    },
    {
      dataField: 'TeamLeadOfficeName',
      text: 'Office',
      sort: true,
    },
    {
      dataField: 'actions',
      text: '',
      formatter: actionsFormatter,
      headerStyle: { width: '30px' },
    },
  ];

  const defaultSorted = [{
    dataField: 'TeamLeadFullName',
    order: 'desc',
  }];

  /*
    Buttons on the bottom left of the table that allow the user to
      decide on how many rows per page should be shown at one time.
  */
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <div className="btn-group" role="group">
      {
        options.map(option => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <Button
              variant={`${isSelect ? 'primary' : 'outline-primary'}`}
              key={option.text}
              onClick={() => onSizePerPageChange(option.page)}
            >
              {option.text}
            </Button>
          );
        })
      }
    </div>
  );

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &nbsp;
      {`Showing rows ${from} to ${to} of ${size}`}
    </span>
  );

  const options = {
    firstPageText: '<<',
    hidePageListOnlyOnePage: true,
    lastPageText: '>>',
    nextPageText: '>',
    paginationTotalRenderer: customTotal,
    prePageText: '<',
    showTotal: true,
    sizePerPageList: [],
    sizePerPage: isModal ? 5 : 10,
    sizePerPageRenderer,
  };

  return (
    <BootstrapTable
      columns={columns}
      data={displayData}
      defaultSorted={defaultSorted}
      wrapperClasses="table-responsive"
      classes="dataTable"
      bordered={false}
      striped
      hover
      id={id}
      keyField="TeamLeadKeyNumeric"
      noDataIndication="No Data Returned."
      pagination={displayData.length > 10 ? paginationFactory(options) : null}
    />
  );
};

TeamLeadersTable.propTypes = {
  id: PropTypes.string,
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  showDeleteButton: PropTypes.bool,
  onMemberDelete: PropTypes.func,
  showStartImpersonationButton: PropTypes.bool,
  isModal: PropTypes.bool,
};

export default TeamLeadersTable;
